import { checkBuyNow } from '@base/product/services';
import type { IVariantNum } from 'base/interfaces/product';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import router from 'next/router';
import { CHECK_BUY_NOW_GO_LOGIN } from 'base/config/constant';
import { checkGroupValid } from '@base/cart/services';

// buy now 跳转检查
export const checkBuyNowHandle = async (variantNums: Array<IVariantNum>) => {
    try {
        await checkBuyNow(variantNums);
    } catch (err) {

        if(err.code === CHECK_BUY_NOW_GO_LOGIN) {
            router.push(generatePath(RouteEnum.LOGIN, { redirect: router.asPath }))
        }
        throw err;
    }
}

// 购物车跳转检查
export const checkGroupValidHandle = async (cartItems: string[]) => {
    try {
        await checkGroupValid(cartItems)
    } catch (err) {
        if(err.code === CHECK_BUY_NOW_GO_LOGIN) {
            router.push(generatePath(RouteEnum.LOGIN, { redirect: router.asPath }))
        }
        throw err;
    }
}